// removed by extract-text-webpack-plugin
module.exports = {"all_shai":"_3HnM4SFdg5rVhwho_7slRj","nav":"Jpg33myVwa31RYWE1dFFD","content":"_2jDdKXmtqUoPSgivIm-Uzk","shaixuan_zimu":"_2fXb5aHEW8y00Ucb7yy5r","itemActive":"rk54Y9emlR_6yaWQhC1VF","shaixuan_wenzi":"_1vSgdiM7g4kfqYkT5fyGe_","shaixuan_wenzi0":"_1SuihzMiE_xr-oBK9Gjc1M"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/QueryNav/QueryNav.scss
 ** module id = 1021
 ** module chunks = 0
 **/